export const IGNORE_ERROR_MESSAGES = [
  'exceeds the threshold',
  'this amount of data can reduce performance',
  'upstream image response timed out',
  'socket hang up',
  'upstream response timed out',
  'operation was aborted due to timeout',
  'warning:',
];

export function isIgnorableMessage(message: string): boolean {
  return IGNORE_ERROR_MESSAGES.some((ignoreMessage) =>
    message.toLowerCase().includes(ignoreMessage.toLowerCase())
  );
}
